import React from "react";
const RecorderButton = ({ isRecording, onClick }) => (
  <button
    className={`record-button ${isRecording ? "recording" : ""}`}
    onClick={onClick}
  >
    {isRecording ? "Stop & Upload" : "Start Recording"}
  </button>
);
export default RecorderButton;
